export enum TopNavBarTabs {
    ALL_INSIGHTS = "All insights",
    YOUR_INSIGHT_DECKS = "Your insight decks",
}

export enum TabQueryParamValue {
    GENERATED_INSIGHTS = "generated",
    ALL_INSIGHTS = "insights",
}
